import styled from "styled-components";

export default styled.div`
  margin-top: 3rem;

  .chat-home-page {
    height: calc(var(--vh, 1vh) * 100);

    .background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
  }

  @media screen and (max-width: 768px) {
    .chat-home-page {
      height: calc(var(--vh, 1vh) * 100);

      .background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }
    }
  }
`;
